import React, { useRef, useMemo, useEffect, CSSProperties } from 'react';
import { Box, Input, InputProps } from '@wix/design-system';
import { TextOverflowState } from '@wix/bex-core';
import { observer } from 'mobx-react-lite';
import { st, classes } from './InputOverflow.st.css.js';

export interface InputOverflowProps extends InputProps {
  state: TextOverflowState;
  text: string;
  selected: boolean;
  focused: boolean;
}

const _InputOverflow = (props: InputOverflowProps) => {
  const { state, selected, focused, text, ...inputProps } = props;
  const helperNodeRef = useRef<HTMLInputElement>();

  const hiddenStyles: CSSProperties = useMemo(
    () => ({
      height: 0,
      visibility: 'hidden',
    }),
    [],
  );

  useEffect(() => {
    if (!helperNodeRef.current) {
      return;
    }

    return state.init(helperNodeRef.current);
  }, []);

  return (
    <Box position="relative" direction="vertical">
      <div style={hiddenStyles} aria-hidden>
        <Input
          {...inputProps}
          textOverflow={undefined}
          clearButton={false}
          onClear={undefined}
          value={text}
          inputRef={(node: HTMLInputElement) => {
            if (node) {
              helperNodeRef.current = node;
            }
          }}
        />
      </div>
      <Input
        {...inputProps}
        onKeyDown={(e) => {
          if (
            e.nativeEvent.code === 'Space' &&
            document.querySelectorAll('[data-option-hovered]').length === 0
          ) {
            e.stopPropagation();
          }

          inputProps.onKeyDown?.(e);
        }}
        textOverflow={undefined}
        className={st(classes.root, {
          selected,
          focused,
        })}
      />
    </Box>
  );
};

export const InputOverflow = observer(_InputOverflow);
